import styled from 'styled-components';

const ContactDataWrapper = styled.div`
  justify-self: flex-end;
  word-wrap: break-word;
`;

export default ContactDataWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CallUs/ContactPerson/ContactDataWrapper.jsx